import React from 'react';
import { Info } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

/* Renders a Welsh "coming soon" notice at the top of any long-form
 * survivor page when the user has switched to Welsh but we have not
 * yet translated the body content professionally. The English text
 * below the notice stays intact — WCAG 3.1.2 Language of Parts is
 * handled by wrapping this notice in lang="cy" and leaving the
 * English content as inherited lang="en-GB" from the parent doc. */

export default function CymraegPendingNotice() {
  const { isCy, t, setLang } = useLanguage();
  if (!isCy) return null;

  return (
    <aside
      lang="cy"
      role="note"
      data-testid="cy-pending-notice"
      className="tf-card p-5 sm:p-6 mt-6"
      style={{
        background: 'linear-gradient(180deg, #FFFFFF 0%, #F4EFF8 100%)',
        borderColor: 'var(--tf-purple-light)',
      }}
    >
      <div className="flex items-start gap-3">
        <div
          className="w-10 h-10 rounded-2xl flex items-center justify-center flex-shrink-0"
          style={{
            background: 'var(--tf-bg-secondary)',
            color: 'var(--tf-purple)',
            border: '1px solid var(--tf-purple-light)',
          }}
          aria-hidden="true"
        >
          <Info size={18} />
        </div>
        <div className="flex-1 min-w-0">
          <p
            className="font-body font-bold"
            style={{
              fontSize: 10.5,
              letterSpacing: '0.22em',
              color: 'var(--tf-purple)',
            }}
          >
            {t('cy.pending.eyebrow')}
          </p>
          <h2
            className="font-heading mt-1"
            style={{
              fontSize: 18,
              color: 'var(--tf-text)',
              letterSpacing: '-0.01em',
              lineHeight: 1.25,
            }}
          >
            {t('cy.pending.title')}
          </h2>
          <p
            className="font-body mt-2"
            style={{
              fontSize: 13,
              color: 'var(--tf-text-secondary)',
              lineHeight: 1.6,
            }}
          >
            {t('cy.pending.body')}
          </p>
          <button
            type="button"
            onClick={() => setLang('en')}
            data-testid="cy-pending-switch-en"
            className="mt-3 inline-flex items-center gap-1.5 px-3 py-2 rounded-full font-bold tf-focus"
            style={{
              background: 'var(--tf-purple)',
              color: '#fff',
              border: 'none',
              fontSize: 12,
              cursor: 'pointer',
              minHeight: 40,
            }}
            lang="en-GB"
          >
            {t('cy.pending.continue')}
          </button>
        </div>
      </div>
    </aside>
  );
}
